import React from 'react';
import AccessorialInfo from './AccessorialInfo';
import EditAccessorialForm from './EditAccessorialForm';
const ShipperRateSection = ({ editShipperRate, formFields, referenceAccessorial, accessorial, onChange, onSave, onCancel, renderActions, }) => {
    if (editShipperRate) {
        const editAccessorial = {
            shipper_rate: formFields.shipper_rate,
            shipper_unit_qty: formFields.shipper_unit_qty,
            shipper_begin_datetime: formFields.shipper_begin_datetime,
            shipper_end_datetime: formFields.shipper_end_datetime,
            shipper_location: formFields.shipper_location,
            shipper_description: formFields.shipper_description,
            shipper_note: formFields.shipper_note,
        };
        return (React.createElement(EditAccessorialForm, { carrier_status: formFields.carrier_status, shipper_status: formFields.shipper_status, isCarrier: false, accessorial: editAccessorial, referenceAccessorial: referenceAccessorial, onChange: onChange, onSave: onSave, onCancel: onCancel }));
    }
    const currentAccessorial = {
        shipper_unit_qty: formFields.shipper_unit_qty,
        shipper_rate: formFields.shipper_rate,
        shipper_description: formFields.shipper_description,
        shipper_location: formFields.shipper_location,
        shipper_begin_datetime: formFields.shipper_begin_datetime,
        shipper_end_datetime: formFields.shipper_end_datetime,
        shipper_note: formFields.shipper_note,
        currency: accessorial === null || accessorial === void 0 ? void 0 : accessorial.currency,
        decline_reason_code: accessorial === null || accessorial === void 0 ? void 0 : accessorial.shipper_decline_reason_code,
    };
    return (React.createElement(AccessorialInfo, { dataTestId: 'div-00353f47', isCarrier: false, accessorial: currentAccessorial, referenceAccessorial: referenceAccessorial, actions: renderActions }));
};
export default ShipperRateSection;
